const useQueryParams = () => {
  const queryString = typeof window !== 'undefined' ? window.location.search : '';
  return new URLSearchParams(queryString);
};

export default useQueryParams;
